import styled from '@emotion/styled';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const PaperAddOnsFiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.S16};

  ${MEDIA_QUERY_V2.DESKTOP} {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const PaperAddOnsFilterPillsWrapper = styled.div`
  display: flex;
  gap: ${SPACING.XS};

  ${MEDIA_QUERY_V2.MOBILE} {
    margin: 0 -${SPACING.S24};
    overflow-x: scroll;
    padding: 0 ${SPACING.S24};

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
